<template>
  <div id="advanced-search" class="content-container flex-row">
    <!-- Result Content -->
    <div class="content-container flex-row">
      <div class="content-container flex-column">
        <div class="content-container gray flex-row content-x-scroll content-y-scroll table-results">
          <!-- Pagination -->
          <div class="pagination-loader-container sidebar-padding">
            <div class="pagination-loader">
              <span class="results">Viser <strong>{{list.length | thousands}}</strong> av {{hits | thousands}} treff</span>

              <a href="javascript:;" v-if="loading" class="button primary tiny loading">Last flere <span class="loader-spinner"></span></a>
              <a href="javascript:;" v-else-if="list.length < 1" class="button primary tiny disabled">Last flere</a>
              <a href="javascript:;" v-else-if="list.length < hits" @click="more()" class="button primary tiny">Last flere</a>
              <a href="javascript:;" v-else-if="list.length >= hits" class="button primary tiny disabled">Last flere</a>

              <a href="javascript:;" @click="scrollToTop()" title="Scroll til toppen" class="button tiny scrolltop"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-left"></use></svg></a>
            </div>
          </div>
          <!-- // Pagination -->

          <table class="large fixed sortable clickable sticky-table-header compressed" style="height: 0">
            <thead>
              <tr class="header">
                <th class="c-number sorttable_numeric">#</th>
                <th v-for="(col, index) in columns" :key="col.key + '_' + index" class="handle" :class="col.class" @click="sortColumn(col, index)">
                  {{col.name}}
                  <span id="sorttable_sortfwdind" v-if="sort === col.sortKey && dir === 'ASC'" class="sort-on">&nbsp;</span>
                  <span id="sorttable_sortrevind" v-else-if="sort === col.sortKey && dir === 'DESC'" class="sort-on">&nbsp;</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, trindex) in list" :key="trindex" :class="{'sperret': row.Sperret}">
                <td class="c-number sorttable_numeric">{{trindex + 1}}</td>
                <template v-for="(col, tdindex) in row.row">
                  <td @click="openKunde(row.Kundenr)" v-if="col.tooltip" :key="trindex + '.' + tdindex" :class="col.class" v-tippy :content="col.tooltip">{{col.value}}</td>
                  <td @click="openKunde(row.Kundenr)" v-else :key="trindex + '.' + tdindex" :class="col.class">{{col.value}}</td>
                </template>
              </tr>
              <template v-if="searchDone">
                <tr v-if="list.length < 1"><td colspan="30" style="text-align: left;">Fant ingen kunder...</td></tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- // Result Content -->
  </div>
</template>

<script>
import NodeService from '@/services/NodeService'
import moment from 'moment'
import bus from '@/plugins/event-bus'
import Vue from 'vue'
import VueTippy from 'vue-tippy'
import Papa from 'papaparse'
import fileDownload from 'js-file-download'

Vue.use(VueTippy, {
  directive: 'tippy',
  duration: 0,
  delay: 0,
  followCursor: false,
  arrow: true,
  animateFill: false,
  interactive: false,
  allowHTML: true,
  animation: 'fade',
  // offset: '50,0',
  placement: 'left',
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: true
      }
    }
  }
})

export default {
  name: 'SearchCustomer',
  data () {
    return {
      dragger: null,
      loading: false,
      loaded: 0,
      list: [],
      info: {},
      hits: 0,
      last: null,
      current: [],
      searchDone: false,
      selectedFilters: null,
      sort: 'Kundenr',
      dir: 'DESC'
    }
  },
  beforeDestroy () {
    window.jQuery('body').removeClass('show-sidebar-xxlarge')
  },
  created () {
    window.jQuery('body').addClass('show-sidebar-xxlarge')

    bus.$off('advanced-kunde-search-start')
    bus.$off('advanced-kunde-search-clear-search')
    bus.$off('advanced-kunde-search-clear-filter')
    bus.$off('advanced-kunde-search-after-column-update')
    bus.$off('advanced-kunde-search-export')

    const q = sessionStorage.customerSearchQuery || null

    if (q) {
      this.$store.dispatch('customersearch/saveQuery', q)
        .then(() => {
          // Load settings
          this.loaded = 1

          sessionStorage.removeItem('customerSearchQuery')
        })
    } else {
      this.$store.dispatch('customersearch/saveQuery', '')
        .then(() => {
          // Load settings
          this.loaded = 1

          sessionStorage.removeItem('customerSearchQuery')
        })
    }
  },
  mounted () {
    bus.$on('advanced-kunde-search-start', (q) => this.onSearch(q))
    bus.$on('advanced-kunde-search-clear-search', () => this.onReset())
    bus.$on('advanced-kunde-search-clear-filter', () => this.onResetFilter())
    bus.$on('advanced-kunde-search-after-column-update', () => this.onAfterColumnUpdate())
    bus.$on('advanced-kunde-search-export', () => this.onExportResults())
  },
  watch: {
    loaded: function (newVal) {
      if (newVal && newVal === 1) {
        // If all settings loaded - reload filters, to maybe set dropdown values
        this.selectedFilters = this._.cloneDeep(this.filters) || {}

        if (this.query) {
          this.search()
        }
      }
    }
  },
  computed: {
    query: function () {
      return this.$store.getters['customersearch/query']
    },
    filters: function () {
      return this.$store.getters['customersearch/filters']
    },
    columns: function () {
      // Should handle sorting
      const cols = this.$store.getters['customersearch/columns']

      return cols.filter(c => c.selected)
    },
    columnKeys: function () {
      return this.columns.map((col) => {
        return col.key
      })
    }
  },
  methods: {
    onExportResults: function () {
      if (!this.current || !this.current.length) {
        this.$helpers.showErrorAlert('Feil', 'Fant ingen kunder å eksportere')
        return
      }

      this.rearrange(this.current)
        .then((parsed) => {
          // All export data
          const data = []

          // Add headings
          const item = []

          item.push('#')
          this.columns.forEach(c => {
            item.push(c.name)
          })
          data.push(item)

          // Add values
          let counter = 0
          parsed.list.forEach(r => {
            const item = []
            item.push(++counter)

            r.row.forEach(c => {
              item.push(c.value)
            })

            data.push(item)
          })

          // Make csv and force download...
          const csv = '\ufeff' + Papa.unparse(data, { delimiter: ';' })
          const blob = new Blob([csv], {
            type: 'application/csvcharset=utf-8'
          })

          fileDownload(blob, 'kundesok-' + moment().format('DDMMYYHms') + '.csv')
        })
        .catch(error => {
          console.log('*** CSV Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke eksportere')
        })
    },
    scrollToTop: function () {
      window.jQuery('.table-results').scrollTop(0)
    },
    sortColumn: function (column, index) {
      if (!column.sortKey) {
        // Not sortable
        return
      }

      if (column.sortKey === this.sort) {
        this.dir = this.dir === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sort = column.sortKey
        this.dir = 'ASC'
      }

      this.search()
    },
    openKunde (Kundenr) {
      if (this.info.hasOwnProperty(Kundenr)) {
        console.log('Has kunde')
        // Remove the hover effect, when clicking on a row....
        window.jQuery('#hi-container').removeClass('active')
        window.jQuery(document).unbind('mousemove')

        this.$router.push({
          name: 'KundeCard',
          params: { kunde_id: Kundenr },
          hash: ''
        })
      } else {
        console.log('No kunde in info')
      }
    },
    more () {
      this.search(this.last)
    },
    onAfterColumnUpdate: function () {
      this.rearrange(this.current)
        .then((parsed) => {
          this.list = parsed.list
          this.last = parsed.last
          this.info = parsed.info
        })
    },
    onSearch: function (data) {
      this.$store.dispatch('customersearch/saveQuery', data.query || '')
        .then(() => {
          this.search()
        })
    },
    onReset: function () {
      this.$store.dispatch('objectsearch/saveQuery', '')
    },
    onResetFilter: function () {
      this.$store.dispatch('customersearch/resetSearch', false)
        .then(() => {
          this.selectedFilters = this._.cloneDeep(this.filters)

          this.info = {}
          this.list = []
          this.current = []
          this.hits = 0
          this.last = null

          // Redo search, without filters, if we have a query string
          if (this.query) {
            this.search()
          }
        })
    },
    search: function (from = null) {
      if (this.loading) {
        console.log('Already searching, so skip...')
        return
      }

      this.searchDone = false
      this.loading = true

      const postData = {
        search: {
          q: this.query || '',
          d: this.dir || 'DESC',
          s: this.sort || 'Kundenr',
          f: null,
          l: from ? 250 : 250
        }
      }

      if (from) {
        postData.search.a = from
      }

      const dispatchParams = { query: this.query, filters: this.selectedFilters }

      console.log('*** Search with:', dispatchParams)
      this.$store.dispatch('customersearch/saveSearch', dispatchParams)
        .then(() => {
          this.selectedFilters = this._.cloneDeep(this.filters)
        })

      // For the old search, save query
      localStorage.searchQuery = this.query || ''

      NodeService.kunde(postData)
        .then((response) => {
          // Store response list
          if (!from) {
            this.current = response.data.data
          } else {
            this.current = [...this.current, ...response.data.data]
          }

          this.rearrange(response.data.data)
            .then((parsed) => {
              if (!from) {
                this.list = parsed.list
              } else {
                this.list = [...this.list, ...parsed.list]
              }

              this.last = parsed.last
              this.info = parsed.info

              this.hits = response.data.hits

              console.log(this.list)
            })
        })
        .catch(error => {
          console.log('*** Search error')
          console.log(error)

          const message = this._.has(error, 'response.data.error')
            ? error.response.data.error
            : 'Noe gikk galt, prøv igjen.'

          this.$helpers.showErrorAlert('Feil', message)
        })
        .then(() => {
          this.loading = false
          this.searchDone = true
        })
    },
    rearrange: function (data) {
      return new Promise((resolve, reject) => {
        const retval = {
          list: [],
          info: [],
          last: null,
          sums: 0
        }

        // Parse/format/sort data
        data.forEach(obj => {
          const row = []

          this.columns.forEach(c => {
            let val = this._.get(obj, c.key, c.default)
            let cls = c.class || ''

            if (c.filter && val !== c.default) {
              switch (c.filter) {
                case 'date':
                  val = this.$options.filters.avantidate(val)
                  break
                case 'datetime':
                  val = this.$options.filters.avantidatetime(val)
                  break
                case 'integer':
                  val = this.$options.filters.thousands(val)
                  break
                case 'decimal':
                  val = this.$options.filters.thousandsFloat(val)
                  break
                case 'bool':
                  val = val === true || val === 'true' || val === 'T' ? 'Ja' : 'Nei'
                  break
              }
            }

            row.push({ value: val, class: cls, tooltip: c.tooltip && val !== c.default ? this.$options.filters.truncate(val, 600) : false })
          })

          retval.last = obj._sort
          retval.info[obj.Kundenr] = obj
          retval.list.push({ Kundenr: obj.Kundenr, Sperret: obj.Sperret === 'T', row: row })

          // retval.sums += (obj.Vurderingspris2 ? obj.Vurderingspris2 : 0)
        })

        resolve(retval)
      })
    }
  }
}
</script>

<style scoped>
table tr.sperret * {
  color: red;
}

.uppercase .input {
  text-transform: uppercase;
}

.nowrap {
  white-space: nowrap;
  word-break: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Search/SearchCustomer.vue